import { render, staticRenderFns } from "./CustomerGroupForm.vue?vue&type=template&id=2b6b91f4"
import script from "./CustomerGroupForm.vue?vue&type=script&lang=js"
export * from "./CustomerGroupForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerGroupForm.vue?vue&type=style&index=0&id=2b6b91f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports